import { Component } from '@angular/core';
import { SpinnerService } from '../../../service/shared/spinner-service.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { HttpContext } from '@angular/common/http';
import { SKIP_SPINNER } from '../../../core/interceptors/spinner.interceptor';
 
@Component({
  selector: 'app-global-spinner',
  template: `
    <div class="overlay global-spinner" *ngIf="spinnerService.spinner$ | async">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="60">
      </mat-progress-spinner>
    </div>
  `,
  styleUrls: ['./global-spinner.component.scss'],
  standalone:true,
  imports:[MatProgressSpinnerModule, CommonModule]
})
export class GlobalSpinnerComponent {
  constructor(public spinnerService: SpinnerService) {}
  // In Case Need to override Spinner for any ApiId, Use context like below
  // this.http.get('request_url',skipSpinnerOptions())
  // this.http.post('request_url',body,skipSpinnerOptions())
}